import admin from './admin';

export default [admin];
